import React from 'react';
import { CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
interface CTAButtonProps {
  label: string;
  sub?: string;
  target?: 'purchase' | 'checkout';
  className?: string;
}
export function CTAButton({
  label,
  sub,
  target = 'purchase',
  className = ''
}: CTAButtonProps) {
  const isCheckout = target === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : PURCHASE_ANCHOR} {...isCheckout ? {
    rel: 'noopener'
  } : {}} className={`block w-full rounded-xl bg-turq px-5 py-3.5 text-center font-heading text-base font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#06908E] transition-colors duration-150 ease-out hover:bg-clinical active:translate-y-[3px] active:shadow-[0_3px_0_0_#06908E] sm:text-lg ${className}`} data-id="element-27" data-mp="2fya4d8chqt3n">
      {label}
      {sub ? <span className="mt-0.5 block font-body text-[0.7rem] font-medium normal-case tracking-normal text-white/90" data-id="element-28" data-mp="3cqnja7sruq93">
          {sub}
        </span> : null}
    </a>;
}
export function TrustLine({
  className = ''
}: {
  className?: string;
}) {
  return <p className={`text-center font-heading text-[0.68rem] font-bold uppercase tracking-wide text-muted sm:text-xs ${className}`} data-id="element-29" data-mp="1da8e5pzokni2">
      🛡️ 7-Day Money-Back Guarantee <span className="text-turq" data-id="element-30" data-mp="1ibxot4izqz5m">•</span> 👁️
      Complete 6-in-1 System
    </p>;
}